// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/cloud-logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf-8,%0A%20%20%3Csvg%20viewBox%3D%220%200%2012%209%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M1%205L4%208L11%201%22%20stroke%3D%22white%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%20%20%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles */
.hidden {
    display: none!important;
    visibility: hidden!important;
}

.icon {
    fill: currentColor;
    height: 1em;
    line-height: 1rem;
    max-width: 100%;
    width: 1rem;
    cursor: pointer;
    vertical-align: text-bottom;
}

.icon-blue {
    color: rgb(0, 97, 235);

}

.icon-gray {
    color: #676767;
}

body {
    font-family: "proxima-nova", "proxima nova", "helvetica neue", "helvetica", "arial", sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    color: #031b4e;
    font-size: 1rem; /* This will be 16px */
}

.App {
    display: flex;
    height: 100vh;
}

.strikethrough {
    text-decoration: line-through;
  }  

.sidebar {
    background-color: #031b4d;
    width: 250px;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    padding-top: 2rem;
}

.sidebar ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.sidebar ul li {
    text-align: left;
}

.sidebar a {
    text-decoration: none;
    color: #ffffff;
    display: block;
    padding: 0.6rem 1.3rem;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1rem;
}

.sidebar a:hover {
    background-color: #e5e8ed;
    color: #031b4e;
    font-weight: 600;
}

.sidebar .logo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 32px;
    height: 32px;
    display: block;
    margin: 0.6rem 1.3rem;
    opacity: 0.63;
    transition: opacity 0.4s linear;
}

.sidebar .logo:hover {
    opacity: 1;
}

.logo a {
    all: unset; /* Reset all inherited styles */
}

.main-content {
    position: relative;
    margin-left: 250px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    min-width: 1050px;
}

header {
    color: #031b4e;
    font-size: 0.9rem;
    text-align: left;
    padding: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Shadow for the bottom border */
    z-index: 100;
}

.content-area {
    flex-grow: 1;
    padding: 0px 96px 24px 96px;
    background-color: rgb(243, 245, 249);
}

h1 {
    font-size: 2.4rem;
    font-weight: 300;
}

h2 {
    margin-top: 0;
}

h3 {
    font-size: 1.2rem;
    font-weight: 600;
    letter-spacing: .06rem;
}

h5 {
    margin: 1.3rem 0;
    letter-spacing: .06rem;
    font-size: .8rem;
    line-height: .8rem;
    font-weight: 600;
}

.font-darkGray {
    color: #676767;
}

.font-blueGray {
    color: #5b6987;
}

.font-blue {
    color: #0069ff;
}

.font-size-dot8 {
    font-size: .8rem;
}

.font-weight-400 {
    font-weight: 400;
}

.font-weight-600 {
    font-weight: 600;
}

.border-bottom-lightGray {
    border-bottom: 1px solid #dfdfdf;
}

.sidebar h5 {
    color:#fff;
    padding-left: 1.3rem;
    padding-top: 1.3rem;
}

button {
    appearance: none;
    margin: 0;
    font-family: inherit;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0px 1rem;
    cursor: pointer;
    border-radius: 3px;
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    line-height: 44px;
    height: 48px;
    font-size: 16px;
    text-decoration: none;
    text-align: center;
    white-space: nowrap;
    border-width: 2px;
    border-style: solid;
    border-color: transparent;
}

.button-green {
    color: #fff;
    background: rgb(18, 124, 67);
}

.button-green:hover {
    background: rgb(10, 166, 83);
}

.button-green:focus {
    outline: #031b4e dotted 2px;
    outline-offset: 2px;
}

/* Disabled button styles - prevents hover and focus effects for green buttons */
.button-green:disabled,
.button-green:disabled:hover,
.button-green:disabled:focus {
    cursor: not-allowed; /* Maintain 'not-allowed' cursor */
    background: #f1f1f1; /* Light gray background to indicate disabled state */
    border: 1px solid #f1f1f1; /* Matching border color for a uniform look */
    color: #bbb; /* Light gray text color to indicate disabled state */
    box-shadow: none; /* Remove any box-shadow effects */
}

.button-blue {
    color: #fff;
    background: #0069ff;
    border-color: #0069ff;
}

.button-blue:hover {
    background: #0052ff;
    color: #fff;
}

.button-blue:focus {
    outline: 0;
    box-shadow: 0 0 0 1px #fff,0 0 2px 2px #0069ff;
}

/* Disabled button styles - prevents hover and focus effects */
.button-blue:disabled,
.button-blue:disabled:hover,
.button-blue:disabled:focus {
    cursor: not-allowed; /* Maintain 'not-allowed' cursor */    
    background: #f1f1f1; /* Light gray background to indicate disabled state */
    border: 1px solid #f1f1f1; /* Matching border color for a uniform look */
    color: #bbb; /* Light gray text color to indicate disabled state */
    box-shadow: none; /* Remove any box-shadow effects */
}

.button-blue-transparent {
    background: none;
    color: #0069ff;
    border-color: #0069ff;
}

.button-blue-transparent:hover {
    background: #0069ff;
    color: #fff;
}

.button-blue-transparent:focus {
    outline: 0;
    box-shadow: 0 0 0 1px #fff, 0 0 2px 2px #0069ff;
}

/* Disabled button styles - prevents hover and focus effects for blue transparent buttons */
.button-blue-transparent:disabled,
.button-blue-transparent:disabled:hover,
.button-blue-transparent:disabled:focus {
    cursor: not-allowed; /* Maintain 'not-allowed' cursor */
    background: #f1f1f1; /* Light gray background to indicate disabled state */
    border: 1px solid #f1f1f1; /* Matching border color for a uniform look */
    color: #bbb; /* Light gray text color to indicate disabled state */
    box-shadow: none; /* Remove any box-shadow effects */
}

ul {
    list-style: none;
    padding: 0;
}

ul li {
    padding: 0;
    cursor: pointer;
}

.close {
    color: #aaa;
    float: right;
    font-size: 2rem;
    font-weight: bold;
    margin-left: 1rem;
}

.close:hover, .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.search-container {
    position: relative;
    margin-bottom: 1.3rem;
    margin-top: 1.3rem;
}

.filters-container {
  margin-top: 1.3rem;
}

.quote {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 3rem;
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 1px 2px rgba(3, 27, 78, 0.16), 0 1px 3px rgba(3, 27, 78, 0.2);
    transition: box-shadow 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;
    justify-content: flex-start;
    margin-bottom: 1rem;
}

p {
    margin-block-start: 0.5rem;
    margin-block-end: 0.5rem;
}

.quote-item {
    margin-left: 30px;
}

/* Remove bottom border for the last quote item */
.quote-item:last-child {
    border-bottom: none;
}

.quote-discounts {
    display: flex;
    gap: .5rem;
}

.input {
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    outline: none;
    height: 48px;
    border: 1px solid #f1f1f1;
    line-height: 1.5;
    padding: 0 16px;
    font-size: 1rem;
    border-radius: 3px;
    background-color: #fff;
    max-width: 100%;
    box-sizing: border-box;
}

.input:focus {
    outline: rgb(91, 105, 135) dotted 2px;
    outline-offset: 2px;
    border-color: rgb(0, 97, 235);
}

.footer-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    position: sticky;
    left: 0;
    bottom: 0;
    z-index: 100;
    background: #fff;
    padding: 24px 96px 34px 96px;
    border-top: 1px solid #999;
    color: #212121;
    gap: 2rem;
}

.quote-totals {
    margin: 0;
    flex-grow: 4;
}

.footer-container .discount,
.footer-container .controls {
    margin: 0;
}

.footer-container .controls {
    border: 0;
}

.header-footer-text-large {
    font-weight: 600;
    font-size: 1.3rem;
}

.header-footer-text-medium {
    color: #676767;
    margin-top: 0;
    font-size: 1.1rem;
}

.header-footer-text-small {
    color: #676767;
    margin-top: 0;
    font-size: 0.8rem;
}

.header-footer-text-tiny {
    color: #676767;
    margin-top: 0;
    font-size: 0.6rem;
}

.quote-placeholder {
    color: #888;
    font-size: 1rem;
    text-align: center;
    padding: 20px;
}

.quote-item-header {
    padding: .6rem 0;
}

.quote-item-index {
    margin-right: 14px;
    margin-left: -30px;
    padding: 0 8px 0 10px;
    background: rgb(18, 124, 67);
    border-radius: 3px;
    font-size: 14px;
    line-height: 21px;
    color: rgb(255, 255, 255);
    font-weight: 600;
}

.quote-item-service {
    margin-right: 14px;
}

.quote-item-name {
    margin-right: auto;
    color: rgb(91, 105, 135);
}

.quote-item-name span:hover {
    color: rgb(91, 105, 135);
    text-decoration: none;
    cursor: default;
}

.quote-item-name input {
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    outline: none;
    height: 20px;
    border: 1px solid #f1f1f1;
    line-height: 1.5;
    padding: 0 12px;
    font-size: 0.9rem;
    border-radius: 3px;
    background-color: #fff;
    box-sizing: border-box;
    color: rgb(91, 105, 135);
    width: 300px !important;
}

.quote-item-name input:focus {
    outline: rgb(91, 105, 135) dotted 2px;
    outline-offset: 2px;
    border-color: rgb(0, 97, 235);
}

.quote-item-action-buttons {
    display: flex;
    align-items: center;
    gap: .5rem;
}

.quote-item-body {
    display: flex;
    flex-direction: column;
    gap: 0.6rem; /* Add a vertical gap of 20px between all child elements */
    border-left: 2px solid rgb(229, 232, 237);
    padding: 0.4rem 0 1rem 1.1rem;
}

.quote-item-description {
    gap: 2rem;
}

.quote-item-quantity {
    display: flex;
    gap: 6px;
}

.quote-item-quantity input[type="number"] {
    width: 55px;
}

.action-text {
    cursor: pointer;
    color: rgb(0, 97, 235);
    font-weight: 600;
    background: transparent;
    padding: 0;
    border-radius: 3px;
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    text-decoration: none;
}

.action-text:hover {
    color: rgb(51, 135, 255);
    text-decoration: underline;
}

.content-area-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.company-name {
    margin-left: auto;
    padding-top: 0.5rem;
}

.company-name .input {
    width: 300px; /* Set a specific width */
}

.price {
    line-height: 1rem;
    min-width: -moz-fit-content;
    min-width: fit-content;
}

.dollar {
    display: inline-block;
    font-size: .8rem;
    vertical-align: top;
    position: relative;
    top: 0;
    margin-right: .1rem;
}

.cost {
    font-size: 1.1rem;
    font-weight: 600;

}

.period {
    position: relative;
    font-size: .9rem;
    margin-left: .2rem;
}

.dollar-large {
    font-size: 1rem;
    margin-right: .2rem;
}

.cost-large {
    font-size: 1.6rem;
}

.period-large {
    font-size: 1rem;
    margin-left: .2rem;
}

.flex {
    display: flex;
}

.flex-between {
    justify-content: space-between;
}

.flex-center {
    align-items: center;
}

.flex-right {
    align-items: flex-end;
}

.flex-column {
    flex-direction: column;
}

.flex-start {
    justify-content: flex-start;
}

.flex-end {
    justify-content: flex-end;
}

.gap-dot2 {
    gap: .2rem;
}

.gap-dot5 {
    gap: .5rem;
}

.gap-1 {
    gap: 1rem;
}

.gap-2 {
    gap: 2rem;
}

.checkbox {
    all: unset;
    box-sizing: border-box;
    align-self: center;
    height: 1rem;
    width: 1rem;
}

.checkbox-input {
    all: unset;
    appearance: none;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: block;
    box-shadow: none;
    border-radius: 3px;
    border-style: solid;
    border-width: 1px;
    border-color: rgb(131, 144, 175);
}

.checkbox-input:hover {
    box-shadow: rgb(51, 135, 255) 0px 0px 0px 2px;
}

.checkbox-input:checked {
    border-color: rgb(0, 97, 235);
    border-width: 2px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    center center no-repeat rgb(0, 97, 235);
}

.margins-no {
    margin: 0;
}

.icon-up, .icon-down {
    height: .65em;
    width: .65em;
    fill: rgb(0, 97, 235);
}

.estimate-id {
    margin-top: 8px;
    min-width: -moz-fit-content;
    min-width: fit-content;
    padding: 0 8px 0 10px;
    background: rgb(91, 105, 135);
    border-radius: 3px;
    font-size: 14px;
    line-height: 21px;
    color: rgb(255, 255, 255);
    font-weight: 600;
}

.refresh-button {
    appearance: none;
    margin-top: 8px;
    margin-right: -12px;
    overflow: visible;
    font-weight: 600;
    color: rgb(91, 105, 135);
    text-transform: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0px;
    background: transparent;
    vertical-align: middle;
    cursor: pointer;
    border-radius: 3px;
    transition: 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    line-height: 20px;
    height: 20px;
    min-width: 20px;
    max-width: 20px;
    font-size: 16px;
    text-decoration: none;
    text-align: center;
    white-space: nowrap;
    border-width: 2px;
    border-style: solid;
    border-color: transparent;
}

.refresh-button:hover {
    color: rgb(202, 12, 12);
    background: rgb(243, 245, 249);
}



.refresh-icon {
    height: 16px;
    width: 16px;
    fill: currentColor;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;;AAE1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,+FAA+F;IAC/F,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,cAAc;IACd,eAAe,EAAE,sBAAsB;AAC3C;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,6BAA6B;EAC/B;;AAEF;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,OAAO;IACP,MAAM;IACN,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yDAAsD;IACtD,WAAW;IACX,YAAY;IACZ,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU,EAAE,+BAA+B;AAC/C;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,wCAAwC,EAAE,iCAAiC;IAC3E,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,0DAA0D;IAC1D,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA,gFAAgF;AAChF;;;IAGI,mBAAmB,EAAE,kCAAkC;IACvD,mBAAmB,EAAE,qDAAqD;IAC1E,yBAAyB,EAAE,6CAA6C;IACxE,WAAW,EAAE,qDAAqD;IAClE,gBAAgB,EAAE,kCAAkC;AACxD;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,8CAA8C;AAClD;;AAEA,8DAA8D;AAC9D;;;IAGI,mBAAmB,EAAE,kCAAkC;IACvD,mBAAmB,EAAE,qDAAqD;IAC1E,yBAAyB,EAAE,6CAA6C;IACxE,WAAW,EAAE,qDAAqD;IAClE,gBAAgB,EAAE,kCAAkC;AACxD;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,+CAA+C;AACnD;;AAEA,2FAA2F;AAC3F;;;IAGI,mBAAmB,EAAE,kCAAkC;IACvD,mBAAmB,EAAE,qDAAqD;IAC1E,yBAAyB,EAAE,6CAA6C;IACxE,WAAW,EAAE,qDAAqD;IAClE,gBAAgB,EAAE,kCAAkC;AACxD;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,2EAA2E;IAC3E,iEAAiE;IACjE,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,iDAAiD;AACjD;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,0DAA0D;IAC1D,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,0BAA0B;IAC1B,cAAc;IACd,SAAS;AACb;;AAEA;IACI,SAAS;IACT,YAAY;AAChB;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,0DAA0D;IAC1D,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW,EAAE,0DAA0D;IACvE,yCAAyC;IACzC,6BAA6B;AACjC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,0DAA0D;IAC1D,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY,EAAE,yBAAyB;AAC3C;;AAEA;IACI,iBAAiB;IACjB,2BAAsB;IAAtB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;;AAEpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB;2CACuC;AAC3C;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,2BAAsB;IAAtB,sBAAsB;IACtB,qBAAqB;IACrB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,sDAAsD;IACtD,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;AAClC;;;;AAIA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB","sourcesContent":["/* Base styles */\n.hidden {\n    display: none!important;\n    visibility: hidden!important;\n}\n\n.icon {\n    fill: currentColor;\n    height: 1em;\n    line-height: 1rem;\n    max-width: 100%;\n    width: 1rem;\n    cursor: pointer;\n    vertical-align: text-bottom;\n}\n\n.icon-blue {\n    color: rgb(0, 97, 235);\n\n}\n\n.icon-gray {\n    color: #676767;\n}\n\nbody {\n    font-family: \"proxima-nova\", \"proxima nova\", \"helvetica neue\", \"helvetica\", \"arial\", sans-serif;\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    color: #031b4e;\n    font-size: 1rem; /* This will be 16px */\n}\n\n.App {\n    display: flex;\n    height: 100vh;\n}\n\n.strikethrough {\n    text-decoration: line-through;\n  }  \n\n.sidebar {\n    background-color: #031b4d;\n    width: 250px;\n    height: 100vh;\n    position: fixed;\n    left: 0;\n    top: 0;\n    padding-top: 2rem;\n}\n\n.sidebar ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.sidebar ul li {\n    text-align: left;\n}\n\n.sidebar a {\n    text-decoration: none;\n    color: #ffffff;\n    display: block;\n    padding: 0.6rem 1.3rem;\n    font-weight: 400;\n    font-size: 1rem;\n    line-height: 1rem;\n}\n\n.sidebar a:hover {\n    background-color: #e5e8ed;\n    color: #031b4e;\n    font-weight: 600;\n}\n\n.sidebar .logo {\n    background-image: url('/public/assets/cloud-logo.svg');\n    width: 32px;\n    height: 32px;\n    display: block;\n    margin: 0.6rem 1.3rem;\n    opacity: 0.63;\n    transition: opacity 0.4s linear;\n}\n\n.sidebar .logo:hover {\n    opacity: 1;\n}\n\n.logo a {\n    all: unset; /* Reset all inherited styles */\n}\n\n.main-content {\n    position: relative;\n    margin-left: 250px;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    min-width: 1050px;\n}\n\nheader {\n    color: #031b4e;\n    font-size: 0.9rem;\n    text-align: left;\n    padding: 1rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Shadow for the bottom border */\n    z-index: 100;\n}\n\n.content-area {\n    flex-grow: 1;\n    padding: 0px 96px 24px 96px;\n    background-color: rgb(243, 245, 249);\n}\n\nh1 {\n    font-size: 2.4rem;\n    font-weight: 300;\n}\n\nh2 {\n    margin-top: 0;\n}\n\nh3 {\n    font-size: 1.2rem;\n    font-weight: 600;\n    letter-spacing: .06rem;\n}\n\nh5 {\n    margin: 1.3rem 0;\n    letter-spacing: .06rem;\n    font-size: .8rem;\n    line-height: .8rem;\n    font-weight: 600;\n}\n\n.font-darkGray {\n    color: #676767;\n}\n\n.font-blueGray {\n    color: #5b6987;\n}\n\n.font-blue {\n    color: #0069ff;\n}\n\n.font-size-dot8 {\n    font-size: .8rem;\n}\n\n.font-weight-400 {\n    font-weight: 400;\n}\n\n.font-weight-600 {\n    font-weight: 600;\n}\n\n.border-bottom-lightGray {\n    border-bottom: 1px solid #dfdfdf;\n}\n\n.sidebar h5 {\n    color:#fff;\n    padding-left: 1.3rem;\n    padding-top: 1.3rem;\n}\n\nbutton {\n    appearance: none;\n    margin: 0;\n    font-family: inherit;\n    font-weight: 500;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0px 1rem;\n    cursor: pointer;\n    border-radius: 3px;\n    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n    line-height: 44px;\n    height: 48px;\n    font-size: 16px;\n    text-decoration: none;\n    text-align: center;\n    white-space: nowrap;\n    border-width: 2px;\n    border-style: solid;\n    border-color: transparent;\n}\n\n.button-green {\n    color: #fff;\n    background: rgb(18, 124, 67);\n}\n\n.button-green:hover {\n    background: rgb(10, 166, 83);\n}\n\n.button-green:focus {\n    outline: #031b4e dotted 2px;\n    outline-offset: 2px;\n}\n\n/* Disabled button styles - prevents hover and focus effects for green buttons */\n.button-green:disabled,\n.button-green:disabled:hover,\n.button-green:disabled:focus {\n    cursor: not-allowed; /* Maintain 'not-allowed' cursor */\n    background: #f1f1f1; /* Light gray background to indicate disabled state */\n    border: 1px solid #f1f1f1; /* Matching border color for a uniform look */\n    color: #bbb; /* Light gray text color to indicate disabled state */\n    box-shadow: none; /* Remove any box-shadow effects */\n}\n\n.button-blue {\n    color: #fff;\n    background: #0069ff;\n    border-color: #0069ff;\n}\n\n.button-blue:hover {\n    background: #0052ff;\n    color: #fff;\n}\n\n.button-blue:focus {\n    outline: 0;\n    box-shadow: 0 0 0 1px #fff,0 0 2px 2px #0069ff;\n}\n\n/* Disabled button styles - prevents hover and focus effects */\n.button-blue:disabled,\n.button-blue:disabled:hover,\n.button-blue:disabled:focus {\n    cursor: not-allowed; /* Maintain 'not-allowed' cursor */    \n    background: #f1f1f1; /* Light gray background to indicate disabled state */\n    border: 1px solid #f1f1f1; /* Matching border color for a uniform look */\n    color: #bbb; /* Light gray text color to indicate disabled state */\n    box-shadow: none; /* Remove any box-shadow effects */\n}\n\n.button-blue-transparent {\n    background: none;\n    color: #0069ff;\n    border-color: #0069ff;\n}\n\n.button-blue-transparent:hover {\n    background: #0069ff;\n    color: #fff;\n}\n\n.button-blue-transparent:focus {\n    outline: 0;\n    box-shadow: 0 0 0 1px #fff, 0 0 2px 2px #0069ff;\n}\n\n/* Disabled button styles - prevents hover and focus effects for blue transparent buttons */\n.button-blue-transparent:disabled,\n.button-blue-transparent:disabled:hover,\n.button-blue-transparent:disabled:focus {\n    cursor: not-allowed; /* Maintain 'not-allowed' cursor */\n    background: #f1f1f1; /* Light gray background to indicate disabled state */\n    border: 1px solid #f1f1f1; /* Matching border color for a uniform look */\n    color: #bbb; /* Light gray text color to indicate disabled state */\n    box-shadow: none; /* Remove any box-shadow effects */\n}\n\nul {\n    list-style: none;\n    padding: 0;\n}\n\nul li {\n    padding: 0;\n    cursor: pointer;\n}\n\n.close {\n    color: #aaa;\n    float: right;\n    font-size: 2rem;\n    font-weight: bold;\n    margin-left: 1rem;\n}\n\n.close:hover, .close:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.search-container {\n    position: relative;\n    margin-bottom: 1.3rem;\n    margin-top: 1.3rem;\n}\n\n.filters-container {\n  margin-top: 1.3rem;\n}\n\n.quote {\n    box-sizing: border-box;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 3rem;\n    background-color: #fff;\n    border-radius: 3px;\n    box-shadow: 0 1px 2px rgba(3, 27, 78, 0.16), 0 1px 3px rgba(3, 27, 78, 0.2);\n    transition: box-shadow 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n    position: relative;\n    justify-content: flex-start;\n    margin-bottom: 1rem;\n}\n\np {\n    margin-block-start: 0.5rem;\n    margin-block-end: 0.5rem;\n}\n\n.quote-item {\n    margin-left: 30px;\n}\n\n/* Remove bottom border for the last quote item */\n.quote-item:last-child {\n    border-bottom: none;\n}\n\n.quote-discounts {\n    display: flex;\n    gap: .5rem;\n}\n\n.input {\n    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n    outline: none;\n    height: 48px;\n    border: 1px solid #f1f1f1;\n    line-height: 1.5;\n    padding: 0 16px;\n    font-size: 1rem;\n    border-radius: 3px;\n    background-color: #fff;\n    max-width: 100%;\n    box-sizing: border-box;\n}\n\n.input:focus {\n    outline: rgb(91, 105, 135) dotted 2px;\n    outline-offset: 2px;\n    border-color: rgb(0, 97, 235);\n}\n\n.footer-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    position: sticky;\n    left: 0;\n    bottom: 0;\n    z-index: 100;\n    background: #fff;\n    padding: 24px 96px 34px 96px;\n    border-top: 1px solid #999;\n    color: #212121;\n    gap: 2rem;\n}\n\n.quote-totals {\n    margin: 0;\n    flex-grow: 4;\n}\n\n.footer-container .discount,\n.footer-container .controls {\n    margin: 0;\n}\n\n.footer-container .controls {\n    border: 0;\n}\n\n.header-footer-text-large {\n    font-weight: 600;\n    font-size: 1.3rem;\n}\n\n.header-footer-text-medium {\n    color: #676767;\n    margin-top: 0;\n    font-size: 1.1rem;\n}\n\n.header-footer-text-small {\n    color: #676767;\n    margin-top: 0;\n    font-size: 0.8rem;\n}\n\n.header-footer-text-tiny {\n    color: #676767;\n    margin-top: 0;\n    font-size: 0.6rem;\n}\n\n.quote-placeholder {\n    color: #888;\n    font-size: 1rem;\n    text-align: center;\n    padding: 20px;\n}\n\n.quote-item-header {\n    padding: .6rem 0;\n}\n\n.quote-item-index {\n    margin-right: 14px;\n    margin-left: -30px;\n    padding: 0 8px 0 10px;\n    background: rgb(18, 124, 67);\n    border-radius: 3px;\n    font-size: 14px;\n    line-height: 21px;\n    color: rgb(255, 255, 255);\n    font-weight: 600;\n}\n\n.quote-item-service {\n    margin-right: 14px;\n}\n\n.quote-item-name {\n    margin-right: auto;\n    color: rgb(91, 105, 135);\n}\n\n.quote-item-name span:hover {\n    color: rgb(91, 105, 135);\n    text-decoration: none;\n    cursor: default;\n}\n\n.quote-item-name input {\n    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n    outline: none;\n    height: 20px;\n    border: 1px solid #f1f1f1;\n    line-height: 1.5;\n    padding: 0 12px;\n    font-size: 0.9rem;\n    border-radius: 3px;\n    background-color: #fff;\n    box-sizing: border-box;\n    color: rgb(91, 105, 135);\n    width: 300px !important;\n}\n\n.quote-item-name input:focus {\n    outline: rgb(91, 105, 135) dotted 2px;\n    outline-offset: 2px;\n    border-color: rgb(0, 97, 235);\n}\n\n.quote-item-action-buttons {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n}\n\n.quote-item-body {\n    display: flex;\n    flex-direction: column;\n    gap: 0.6rem; /* Add a vertical gap of 20px between all child elements */\n    border-left: 2px solid rgb(229, 232, 237);\n    padding: 0.4rem 0 1rem 1.1rem;\n}\n\n.quote-item-description {\n    gap: 2rem;\n}\n\n.quote-item-quantity {\n    display: flex;\n    gap: 6px;\n}\n\n.quote-item-quantity input[type=\"number\"] {\n    width: 55px;\n}\n\n.action-text {\n    cursor: pointer;\n    color: rgb(0, 97, 235);\n    font-weight: 600;\n    background: transparent;\n    padding: 0;\n    border-radius: 3px;\n    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n    text-decoration: none;\n}\n\n.action-text:hover {\n    color: rgb(51, 135, 255);\n    text-decoration: underline;\n}\n\n.content-area-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.company-name {\n    margin-left: auto;\n    padding-top: 0.5rem;\n}\n\n.company-name .input {\n    width: 300px; /* Set a specific width */\n}\n\n.price {\n    line-height: 1rem;\n    min-width: fit-content;\n}\n\n.dollar {\n    display: inline-block;\n    font-size: .8rem;\n    vertical-align: top;\n    position: relative;\n    top: 0;\n    margin-right: .1rem;\n}\n\n.cost {\n    font-size: 1.1rem;\n    font-weight: 600;\n\n}\n\n.period {\n    position: relative;\n    font-size: .9rem;\n    margin-left: .2rem;\n}\n\n.dollar-large {\n    font-size: 1rem;\n    margin-right: .2rem;\n}\n\n.cost-large {\n    font-size: 1.6rem;\n}\n\n.period-large {\n    font-size: 1rem;\n    margin-left: .2rem;\n}\n\n.flex {\n    display: flex;\n}\n\n.flex-between {\n    justify-content: space-between;\n}\n\n.flex-center {\n    align-items: center;\n}\n\n.flex-right {\n    align-items: flex-end;\n}\n\n.flex-column {\n    flex-direction: column;\n}\n\n.flex-start {\n    justify-content: flex-start;\n}\n\n.flex-end {\n    justify-content: flex-end;\n}\n\n.gap-dot2 {\n    gap: .2rem;\n}\n\n.gap-dot5 {\n    gap: .5rem;\n}\n\n.gap-1 {\n    gap: 1rem;\n}\n\n.gap-2 {\n    gap: 2rem;\n}\n\n.checkbox {\n    all: unset;\n    box-sizing: border-box;\n    align-self: center;\n    height: 1rem;\n    width: 1rem;\n}\n\n.checkbox-input {\n    all: unset;\n    appearance: none;\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n    display: block;\n    box-shadow: none;\n    border-radius: 3px;\n    border-style: solid;\n    border-width: 1px;\n    border-color: rgb(131, 144, 175);\n}\n\n.checkbox-input:hover {\n    box-shadow: rgb(51, 135, 255) 0px 0px 0px 2px;\n}\n\n.checkbox-input:checked {\n    border-color: rgb(0, 97, 235);\n    border-width: 2px;\n    background: url(\"data:image/svg+xml;charset=utf-8,%0A%20%20%3Csvg%20viewBox%3D%220%200%2012%209%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M1%205L4%208L11%201%22%20stroke%3D%22white%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%20%20%3C%2Fsvg%3E\")\n    center center no-repeat rgb(0, 97, 235);\n}\n\n.margins-no {\n    margin: 0;\n}\n\n.icon-up, .icon-down {\n    height: .65em;\n    width: .65em;\n    fill: rgb(0, 97, 235);\n}\n\n.estimate-id {\n    margin-top: 8px;\n    min-width: fit-content;\n    padding: 0 8px 0 10px;\n    background: rgb(91, 105, 135);\n    border-radius: 3px;\n    font-size: 14px;\n    line-height: 21px;\n    color: rgb(255, 255, 255);\n    font-weight: 600;\n}\n\n.refresh-button {\n    appearance: none;\n    margin-top: 8px;\n    margin-right: -12px;\n    overflow: visible;\n    font-weight: 600;\n    color: rgb(91, 105, 135);\n    text-transform: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    padding: 0px;\n    background: transparent;\n    vertical-align: middle;\n    cursor: pointer;\n    border-radius: 3px;\n    transition: 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n    line-height: 20px;\n    height: 20px;\n    min-width: 20px;\n    max-width: 20px;\n    font-size: 16px;\n    text-decoration: none;\n    text-align: center;\n    white-space: nowrap;\n    border-width: 2px;\n    border-style: solid;\n    border-color: transparent;\n}\n\n.refresh-button:hover {\n    color: rgb(202, 12, 12);\n    background: rgb(243, 245, 249);\n}\n\n\n\n.refresh-icon {\n    height: 16px;\n    width: 16px;\n    fill: currentColor;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
